import { Col, Row } from "antd";
import view from "src/shared/assets/images/landing/view.svg";
import InstaStructure from "./instaStructure";

const LInstaView = ({ data, id }: any) => {
  return (
    <InstaStructure
      h3="افزایش بازدید واقعی ایرانی"
      svg={view}
      p="به وسیله این بسته شما می توانید اقدام به خرید بازدید کنید و
    بازدیدهای اکانت رو افزایش دهید.بازدیدهای ارائه شده در سایت
    بسیار باکیفیت و ایرانی هستند .خودتون امتحان کنید."
      color={2}
      h4="افزایش بازدید واقعی ایرانی"
      data={data}
      id={id}
    />
  );
};

export default LInstaView;
